import React from "react";
import styled from "styled-components";
import Clipart from '/src/assets/contact/clipart.svg';
import { Text, MiddleLayout, Link, SEO } from 'src/components/Common';
import ContactUsFrom from '../LetsTalk/ContactUsFrom';
import { only, between } from 'styled-breakpoints';
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';
import { useLocation } from "@reach/router"

const Root = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-image: url('/images/contact_background.svg');
  background-repeat: no-repeat;
  background-size: cover;

  ${between('mini', 'mobile')} {
    padding: 50px 0 20px 0;
    background-image: url('/images/contact_background_mobile.svg');
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${between('mini', 'mobile')} {
    flex-direction: column;
    width: 100%;
  }
`;

const ClipartWrapper = styled.div`
  ${between('mini', 'mobile')} {
   display: none;
  }
`;

const RightSide = styled.div`
  width: 60%;

  ${between('mini', 'mobile')} {
    width: 100%;
  }

  ${only('laptop')} {
    width: 100%;
  };
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 30px;
`;

const Success = styled.div`
`;

const GoToHomePage = styled(Text)`
    text-decoration: underline;
`;

const ContactUs = ({ isSuccess }) => {
  const { i18n } = useI18next();
  const { t } = useTranslation();
  const { href } = useLocation();

  const breadcrumbsElementsSchema = [{
    "@type": "ListItem",
    "position": 2,
    "name": t("Contact"),
    "item": href
  }];

  const renderSuccess = () => (
    <Success>
      <Texts>
        <Text text="Thank You" variant="h3" isBold component="h1" color="white" />
        <Text text="Your message has been received" variant="h5" component="p" color="white" />
        <Text text="We will contact you soon :)" variant="h5" component="p" color="white" />
      </Texts>
      <Link to="/">
        <GoToHomePage text="Go to homepage" variant="h6" component="h1" color="white" />
      </Link>
    </Success>
  );

  return (
    <Root dir="ltr">
      <SEO
        title="SEO title contact"
        description="SEO description contact"
        breadcrumbsElementsSchema={breadcrumbsElementsSchema}
      />
      <MiddleLayout>
        <Content>
          <ClipartWrapper>
            <Clipart />
          </ClipartWrapper>
          <RightSide dir={i18n?.dir()}>
            {isSuccess ? renderSuccess() : (
              <>
                <Texts>
                  <Text text="Contact Us" variant="h3" isBold component="h1" color="white" />
                  <Text text="Let us know how we can assist you" variant="h5" color="white" />
                </Texts>
                <ContactUsFrom
                  fullWidth
                  button="info"
                  autoFocus
                  buttonId="ContactUsPageButton"
                />
              </>
            )}
          </RightSide>
        </Content>
      </MiddleLayout>
    </Root>
  );
}

export default ContactUs;
